import React from 'react';

/**
 * Props for the CaseSearch component
 */
export interface CaseSearchProps {
  value: string;
  onChange: (query: string) => void;
  placeholder?: string;
}

/**
 * CaseSearch component - renders a search input field for filtering cases by student name.
 * 
 * Accepts value and onChange props for controlled input behavior.
 * Includes an optional placeholder prop with a sensible default.
 * 
 * Requirements: 4.1
 */
export const CaseSearch: React.FC<CaseSearchProps> = ({
  value,
  onChange,
  placeholder = 'Search by student name...',
}) => {
  return (
    <div
      data-testid="case-search"
      style={{
        position: 'relative',
        width: '100%',
        maxWidth: '300px',
      }}
    >
      <input
        type="text"
        data-testid="case-search-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          width: '100%',
          padding: '10px 12px 10px 36px',
          borderRadius: '8px',
          border: '1px solid #ddd',
          fontSize: '14px',
          outline: 'none',
          transition: 'border-color 0.2s, box-shadow 0.2s',
        }}
        onFocus={(e) => {
          e.currentTarget.style.borderColor = '#1976d2';
          e.currentTarget.style.boxShadow = '0 0 0 2px rgba(25, 118, 210, 0.2)';
        }}
        onBlur={(e) => {
          e.currentTarget.style.borderColor = '#ddd';
          e.currentTarget.style.boxShadow = 'none';
        }}
      />
      <svg
        style={{
          position: 'absolute',
          left: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '18px',
          height: '18px',
          color: '#999',
        }}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>
  );
};
